const Footer = () => {
  return (
    <footer className="mt-auto border-t border-[var(--ui-03)] bg-[#f5f7f8] px-8 py-6 text-sm">
      <div className="mx-auto flex w-full max-w-[1700px] justify-end">
        <div>{new Date().getFullYear()} &copy; World Food Programme</div>
      </div>
    </footer>
  );
};

export default Footer;
